import { AxiosResponse } from 'axios'
import { ApiRepository } from 'repository/api-repository'
import { ApiResponse } from 'service/protocols/api/api-client'
import {
  IApiRepository,
  RepositoryRequest
} from 'service/protocols/api/api-repository'
import { GetStorage } from 'service/protocols/cache/get-storage'

export class PrepareApiRequestDecorator implements IApiRepository {
  constructor(
    private readonly getStorage: GetStorage,
    private readonly apiRepository: ApiRepository
  ) {}

  async post(data: RepositoryRequest): Promise<ApiResponse> {
    const account = this.getStorage.get('account')
    if (account?.accessToken) {
      Object.assign(data, {
        headers: Object.assign(data.headers || {}, {
          authorization: 'Bearer ' + account.accessToken
        })
      })
    }
    data.url = `${process.env.REACT_APP_API_URL + data.url}`

    return await this.apiRepository.post(data)
  }

  async get(
    data: RepositoryRequest,
    is_file?: boolean
  ): Promise<ApiResponse | AxiosResponse> {
    const account = this.getStorage.get('account')
    if (account?.accessToken) {
      Object.assign(data, {
        headers: Object.assign(data.headers || {}, {
          authorization: 'Bearer ' + account.accessToken
        })
      })
    }
    data.url = `${process.env.REACT_APP_API_URL + data.url}`

    return await this.apiRepository.get(data, is_file)
  }
}
